import axios, { AxiosError, AxiosHeaders, HeadersDefaults, RawAxiosRequestHeaders } from 'axios';
import axiosRetry, { isNetworkOrIdempotentRequestError } from 'axios-retry';
import globalErrorUtils from 'hooks/globalErrorUtils';
import embeddedAppUtils from './embeddedAppUtils';
import storageService, { Locals } from './storageService';

const headers = (accessToken?: string): RawAxiosRequestHeaders | AxiosHeaders | Partial<HeadersDefaults> => {
    if (!embeddedAppUtils.isAppEmbedded()) {
        accessToken = storageService.getObject(Locals.ACCESS_TOKEN);
    }
    if (accessToken) {
        return {
            Authorization: `Bearer ${accessToken}`,
        };
    } else {
        return {};
    }
};

const api = axios.create({
    baseURL: '',
    headers: headers(),
    paramsSerializer: {
        // Axios's default encoder runs every key/value through `encodeURIComponent`, which turns
        // array-style keys like `provider[]` into `provider%5B%5D` — some backends only match the
        // literal bracket form, so un-escape just those two sequences after encoding everything else.
        encode: (value: string) => encodeURIComponent(value).replace(/%5B/g, '[').replace(/%5D/g, ']'),
    },
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return globalErrorUtils.handleError(error);
    }
);

const updateHeaders = (token?: string) => {
    Object.assign(api.defaults.headers, headers(token));
};

axiosRetry(api, {
    retries: 3,
    retryCondition: (e: AxiosError): boolean => {
        return isNetworkOrIdempotentRequestError(e) || e.response?.status === 401;
    },
    retryDelay: (retryCount) => {
        return retryCount * 600;
    },
});

export { api, updateHeaders };
